"use client";

import { ThemeProvider } from "next-themes";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import React from "react";

import { CookieConsentBanner } from "../layout/cookie-consent-banner";
import { TailwindIndicator } from "../tailwind-indicator";
import { Toaster } from "../ui/sonner";
import { TooltipProvider } from "../ui/tooltip";
import { AuthBootstrap } from "./auth-bootstrap";
import { AuthProvider } from "./auth-provider";
import { NotificationsProvider } from "@/feature/notifications/components/notifications-provider";
import { ReduxProvider } from "./redux-provider";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ReduxProvider>
      <AuthBootstrap />
      <AuthProvider>
        <NotificationsProvider>
          <ThemeProvider
            attribute="class"
            defaultTheme="light"
            enableSystem
            disableTransitionOnChange
            enableColorScheme
          >
            <TooltipProvider>
              <NuqsAdapter>
                {children}
                <CookieConsentBanner />
                {/* <GlobalSearchTransition /> */}
              </NuqsAdapter>

              <Toaster position="top-center" richColors duration={5000} />
              <TailwindIndicator />
            </TooltipProvider>
          </ThemeProvider>
        </NotificationsProvider>
      </AuthProvider>
    </ReduxProvider>
  );
}
